import {
    buildLocalBusinessSchema,
    buildProductSchema,
    buildBreadcrumbSchema,
    buildFAQSchema,
    buildSpeakableSchema,
} from "../../../shared/seo/schemas";
import type { SeoHeadProps } from "../../../shared/seo/SeoHead";
import { SITE_BASE } from "../../../shared/seo/siteUrl";

const BASE = SITE_BASE;
const URL = `${BASE}/faux-fur-pom-poms`;

const FAQS = [
    { q: "What is the minimum order quantity for faux fur pom poms?", a: "Standard MOQ is 100 pieces per design and colour. Custom-coloured or branded orders begin at 200 pieces. Bulk discounts above 500 pieces." },
    { q: "Are your faux fur pom poms cruelty-free and vegan?", a: "Yes. 100% synthetic, cruelty-free and vegan-certified. We use premium acrylic and modacrylic fibres that mimic real fur without animal products." },
    { q: "Do you ship faux fur pom poms internationally from India?", a: "Yes — primary markets USA, UK, EU, Germany, France, UAE, Australia, Canada. Lead time 10-21 days sea / 3-7 days air." },
    { q: "What sizes of faux fur pom poms do you manufacture?", a: "Seven standard sizes: 6cm, 8cm, 10cm (most popular), 12cm, 15cm, 20cm and 25cm. Custom sizes available above 500 pcs." },
    { q: "Can you supply pom poms with snap buttons?", a: "Yes — snap-on faux fur pom poms are our most popular variant. KAM brand snaps in nickel, gold or custom-coloured finishes." },
];

export const FauxFurPomPomSeo: SeoHeadProps = {
    title: "Faux Fur Pom Poms Manufacturer Delhi | Wholesale Export India",
    description:
        "Premium faux fur pom poms manufacturer in Delhi, India. Snap-on, detachable, custom-coloured pom poms for beanies, hats, keychains & bag charms. 60+ colours. MOQ 100 pcs. Cruelty-free.",
    keywords:
        "faux fur pom poms manufacturer Delhi, faux fur pom poms supplier India, faux fur pom poms exporter India, wholesale faux fur pom poms, snap on faux fur pom poms, detachable fur pom poms, faux fur beanie pom poms, faux fur pom pom keychain, vegan fur pom poms India, cruelty free pom poms manufacturer",
    canonical: URL,
    author: "Arte Craft India",
    robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",

    ogType: "product",
    ogUrl: URL,
    ogSiteName: "Arte Craft India",
    ogImage: `${BASE}/images/faux-fur-pom-poms-og.jpg`,
    ogImageAlt: "Colourful faux fur pom poms — snap-on, tie-on and sew-on — from Arte Craft India Delhi",
    ogLocale: "en_IN",
    ogLocaleAlternates: ["en_US", "en_GB", "en_AU", "en_AE"],

    twitterCard: "summary_large_image",
    twitterSite: "@ArteCraftIndia",
    twitterCreator: "@ArteCraftIndia",
    twitterImage: `${BASE}/images/faux-fur-pom-poms-twitter.jpg`,
    twitterImageAlt: "Faux fur pom poms from Arte Craft India Delhi manufacturer",
    twitterLabel1: "Material",
    twitterData1: "Premium synthetic faux fur (cruelty-free, 60+ colours)",
    twitterLabel2: "MOQ",
    twitterData2: "100 pieces — bulk discount from 500 pcs",

    aiBots: true,

    geoRegion: "IN-DL",
    geoPlacename: "Badarpur, New Delhi, India",
    geoPosition: "28.5045;77.2855",

    dublinCore: {
        title: "Faux Fur Pom Poms Manufacturer Delhi | Wholesale Export India",
        creator: "Arte Craft India",
        subject: "Faux Fur Pom Poms, Manufacturing, Wholesale, Export, Delhi, India",
        description: "Premium faux fur pom poms manufacturer in Delhi for global export.",
        publisher: "Arte Craft India Pvt Ltd, Delhi",
        date: "2026-05-26",
        type: "Service, Product Catalog, Manufacturer Profile",
        language: "en",
        rights: "© 2026 Arte Craft India Pvt Ltd. All rights reserved.",
    },

    hreflangs: [
        { lang: "en-IN", url: URL },
        { lang: "en-US", url: URL },
        { lang: "en-GB", url: URL },
        { lang: "en-AU", url: URL },
        { lang: "en-AE", url: URL },
        { lang: "en", url: URL },
        { lang: "x-default", url: URL },
    ],

    productBrand: "Arte Craft India",
    productAvailability: "in stock",
    productCondition: "new",
    productPriceAmount: "15.00",
    productPriceCurrency: "INR",
    productMaterial: "Premium synthetic faux fur (cruelty-free)",
    productColor: "60+ shades — natural raccoon-look, fox, beige, jet black, neon brights",
    productSize: "6cm · 8cm · 10cm · 12cm · 15cm · 20cm · 25cm",
    productCategory: "Apparel & Accessories > Fur & Faux Fur > Pom Poms",

    themeColor: "#1B4F72",

    jsonLd: [
        buildLocalBusinessSchema(),
        buildProductSchema({
            name: "Faux Fur Pom Poms — Snap-On · Detachable · Custom",
            sku: "AC-FFPP-001",
            canonicalUrl: URL,
            imageSlug: "faux-fur-pom-poms",
            description:
                "Premium cruelty-free faux fur pom poms manufactured in Delhi. 60+ colours, 7 sizes (6cm–25cm). Snap-on, tie-on, sew-on. Wholesale & export.",
            material: "Premium synthetic faux fur (acrylic / modacrylic)",
            color: "60+ shades",
            sizes: ["6cm", "8cm", "10cm", "12cm", "15cm", "20cm", "25cm"],
            category: "Apparel & Accessories > Fur & Faux Fur > Pom Poms",
            lowPrice: "15",
            highPrice: "180",
        }),
        buildBreadcrumbSchema([
            { name: "Home", url: `${BASE}/` },
            { name: "Products", url: `${BASE}/products` },
            { name: "Pom Poms", url: `${BASE}/products/pom-poms` },
            { name: "Faux Fur Pom Poms", url: URL },
        ]),
        buildFAQSchema(FAQS),
        buildSpeakableSchema(URL, "Faux Fur Pom Poms Manufacturer Delhi | Wholesale Export India", "faux-fur-pom-poms"),
    ],
};
